import { useState } from "react";
import AddEquation from "./addEquation";
import GameTypeList from "./GameTypeList";

export default function ( props  ) {

    const { setGameTypeEquation, gameTypeEquation, gameTypeData } = props;
    const [currentGameType, setcurrentGameType] = useState();
  
   
    return(
       <>
        <GameTypeList
            setCurrentGameType={setcurrentGameType}
            gameTypeData={gameTypeData}
            currentGameType={currentGameType}
       />
        <div className='grid grid-cols-[4fr,1fr] gap-2'>
            <div className='flex justify-center w-full'>
                <AddEquation   
                    currentGameType={currentGameType} 
                    gameTypeEquation={gameTypeEquation} 
                    setGameTypeEquation={setGameTypeEquation}
                />
            </div>
        </div>
       </>
    )

}